import { render, staticRenderFns } from "./UploadPhoto2.vue?vue&type=template&id=6678ed64&lang=pug&"
import script from "./UploadPhoto2.vue?vue&type=script&lang=js&"
export * from "./UploadPhoto2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports